module.exports = __webpack_public_path__ + "img/1.ca46da05.jpg";